import classNames from 'classnames';
import React from 'react';

import {useI18n} from '@udemy/i18n';
import {Icon} from '@udemy/icons';
import {OnePaneLayoutFullWidthSectionContent} from '@udemy/react-layout-components';

import {CoursesCarouselList} from '../courses-carousel-list/courses-carousel-list.react-component';
import styles from './reimagine-career-carousel.module.less';
import {
    UseReimagineCareerCoursesByIdsResult,
    withReimagineCareerCarouselCoursesData,
} from './with-reimagine-career-carousel-courses-data.react-component';

const MAX_COURSES_PER_ROW = 4;

type ReimagineCareerCarouselProps = {
    maxCoursesPerRow?: number;
};

const ReimagineCareerCoursesCarousel = withReimagineCareerCarouselCoursesData(
    ({
        coursesResult: {count, isLoading, courses},
        maxCoursesPerRow = MAX_COURSES_PER_ROW,
    }: {coursesResult: UseReimagineCareerCoursesByIdsResult} & ReimagineCareerCarouselProps) => {
        return (
            <CoursesCarouselList
                courses={courses}
                totalCount={count}
                isLoading={isLoading}
                maxCoursesPerRow={maxCoursesPerRow}
            />
        );
    },
);

export const ReimagineCareerCarousel = ({maxCoursesPerRow}: ReimagineCareerCarouselProps) => {
    const {gettext} = useI18n();

    return (
        <OnePaneLayoutFullWidthSectionContent
            role="region"
            aria-labelledby="reimagine-career-carousel-heading"
            className={styles['reimagine-career-carousel']}
        >
            <div className={styles['icon-casing']}>
                <Icon glyph="expand-plus" size="large" label={false} />
            </div>

            <div className={styles.header}>
                <h3
                    id="reimagine-career-carousel-heading"
                    className={classNames('ud-heading-xxl', styles['heading'])}
                >
                    {gettext('Build AI skills for in-demand fields')}
                </h3>

                <div className={classNames('ud-text-lg', styles['description'])}>
                    {gettext(
                        'From project management to IT support, learn to apply AI through practical, interactive activities that help you stay ahead in a fast-changing world.',
                    )}
                </div>
            </div>
            <div className={styles.content}>
                <ReimagineCareerCoursesCarousel maxCoursesPerRow={maxCoursesPerRow} />
            </div>
        </OnePaneLayoutFullWidthSectionContent>
    );
};
